import styled from "styled-components";

interface JourneyWrapperProps {
  isPassengerInfoShown: boolean;
}

const JourneyWrapper = styled.div<JourneyWrapperProps>`
  display: ${({ isPassengerInfoShown }) =>
    isPassengerInfoShown ? "flex" : "block"};
  background-color: ${({ theme }) => theme.colors.journeySectionBackground};
  border-radius: 0px;
  width: 100%;
  justify-content: space-between;
  align-items: center;

  @media all and (max-width: ${({ theme }) => theme.mobileBreakingPoint}) {
    position: absolute;
    border-top: 1px solid ${({ theme }) => theme.colors.base3};
    border-bottom: 1px solid ${({ theme }) => theme.colors.base3};
    top: 0;
    left: 0;
    right: 0;
    height: 200px;
  }
`;

export default JourneyWrapper;
